import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService } from '@crosscutting/public_api';
import { environment } from '@env/environment';
import { ClaimOverview, OphalenClaimResponse } from '@models/claims';

@Injectable()
export class SitecoreClaimService {
  constructor(private _http: HttpService) { }

  getClaimnummer(hash: string): Observable<String> {
    return this._http.get<String>(environment.raadplegenClaimnummerUrl + '?qsd=' + hash);
  }

  getClaimOverview(): Observable<ClaimOverview> {
    return this._http.get<ClaimOverview>(environment.claimOverviewUrl);
  }

  getSchademeldingdetail(hash: string): Observable<OphalenClaimResponse> {
    return this._http.get<OphalenClaimResponse>(environment.raadplegenClaimDetailsUrl + '?qsd=' + hash)
      .pipe(map(response => {
        return response;
      }));
  }
}
